// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_11-1";
export var movingGradient = "_11-4";
export var movingGradientBlock = "_11-2";
export var skeleton = "_11-0";
export var skeletonText = "_11-3";